import React from "react";
import DataTable from "../../common/ui/data-table/DataTable";
import TableContainer from "../../common/ui/table-container/TableContainer";

const noopSort = () => {};

const DEFAULT_STATE_CELL_STYLE = { padding: "1.5rem", textAlign: "center", color: "#6b7280" };

/**
 * Payroll lists: same shell as Documents / Compliance — {@link DataTable} + {@link TableContainer}
 * so header and body cells pick up `DataTable.css` (uppercase headers, padding, borders).
 */
const PayrollDataGrid = ({
  columns,
  rows,
  getRowKey,
  renderRow,
  onRowClick,
  emptyMessage,
  loading = false,
  loadingMessage,
  sortKey = "",
  sortDir = "asc",
  onSort = noopSort,
  getRowClassName,
  stateCellStyle = DEFAULT_STATE_CELL_STYLE,
}) => (
  <div className="documents-table-wrap payroll-data-grid-wrap">
    <TableContainer>
      <DataTable
        className="documents-table"
        columns={columns}
        rows={rows}
        getRowKey={getRowKey}
        renderRow={renderRow}
        onRowClick={onRowClick}
        getRowClassName={getRowClassName}
        sortKey={sortKey}
        sortDir={sortDir}
        onSort={onSort}
        loading={loading}
        loadingMessage={loadingMessage}
        emptyMessage={emptyMessage}
        stateCellStyle={stateCellStyle}
      />
    </TableContainer>
  </div>
);

export default PayrollDataGrid;

/** Use on action columns so header/body align with documents grids */
export const payrollActionsHeaderClass = "documents-table-th-actions data-table-th-actions";
export const payrollActionsCellClass = "documents-table-td-actions data-table-td-actions";
